export const appName = "Fire History Tracker";
export const subtitle = ""; //"The tracker to all the fires ever in the history of Utah";
export const DEMLogoUrl = "/DEM.png";
export const FFSLLogoUrl = "/FFSL.png";
export const USULogoUrl = "/USU.png";
export const naValue = "Not Available";

export const utahExtent = [-115.95661879868166, 36.498418308607825, -107.3268580564942, 42.53875157357021];

export const initCenter = [Number(-111.63457179829607), Number(39.58463546489155)];
export const initZoom = 6;

  
export const chocolateFondue = "rgb(154, 47, 0)";
export const hotBologonese = "rgb(203, 77, 20)";
export const bambooGrassGreen = "rgb(129, 150, 80)";
export const blindForest = "rgb(32, 61, 6)";
export const jenembaRed = "rgb(255,34,24)";
export const ebony = "rgb(47, 51, 55)";
export const white = "rgb(255,255,255)";

export const paletteColors = {
    chocolateFondue,
    hotBologonese,
    bambooGrassGreen,
    blindForest,
    jenembaRed,
    ebony,
    white
};

const exports = {
    appName,
    subtitle,
    DEMLogoUrl,
    FFSLLogoUrl,
    USULogoUrl,
    naValue,
    utahExtent,
    initCenter,
    initZoom,
    paletteColors,
};

export default exports
